var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIres5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43,44H21c-1.105,0-2-0.895-2-2V22c0-1.105,0.895-2,2-2h22c1.105,0,2,0.895,2,2v20    C45,43.105,44.105,44,43,44z",
    style: {
      fill: "#FFCB57"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43,19H21c-1.654,0-3,1.346-3,3v20c0,1.654,1.346,3,3,3h22c1.654,0,3-1.346,3-3V22    C46,20.346,44.654,19,43,19z M44,22v5h-3v-2h-4v-4h2v2h2v-2h2C43.551,21,44,21.448,44,22z M41,33h3v2h-3V33z M41,31v-2h3v2H41z     M31,39v4h-2v-4H31z M33,39h2v4h-2V39z M25,37V27h14v10H25z M33,25v-4h2v4H33z M31,25h-2v-4h2V25z M21,21h2v2h2v-2h2v4h-4v2h-3v-5    C20,21.448,20.449,21,21,21z M23,35h-3v-2h3V35z M23,31h-3v-2h3V31z M20,42v-5h3v2h4v4h-2v-2h-2v2h-2C20.449,43,20,42.552,20,42z     M43,43h-2v-2h-2v2h-2v-4h4v-2h3v5C44,42.552,43.551,43,43,43z",
    style: {
      fill: "#3F3A34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,35h10v-6H27V35z M29,31h6v2h-6V31z",
    style: {
      fill: "#3F3A34"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 33,
    y: 47
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 33,
    y: 61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 29,
    y: 47
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 29,
    y: 61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "27,57 11,57 11,55 25,55 25,47 27,47   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 7,
    y: 55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "23,53 5,53 5,51 21,51 21,47 23,47   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 1,
    y: 51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "53,57 37,57 37,47 39,47 39,55 53,55   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 55,
    y: 55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "59,53 41,53 41,47 43,47 43,51 59,51   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 61,
    y: 51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 29,
    y: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 29,
    y: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 12,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 33,
    y: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 33,
    y: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "39,17 37,17 37,7 53,7 53,9 39,9   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 55,
    y: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "43,17 41,17 41,11 59,11 59,13 43,13   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 61,
    y: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "27,17 25,17 25,9 11,9 11,7 27,7   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 7,
    y: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "23,17 21,17 21,13 5,13 5,11 23,11   ",
    style: {
      fill: "#E56565"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 1,
    y: 11
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIres5);
export default __webpack_public_path__ + "static/media/AIres5.d797e9d6bfe3119dd9b23cfaa5f1ecf5.svg";
export { ForwardRef as ReactComponent };